"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetAvailabilities = exports.updateOwner = exports.marketplaceSlice = exports.marketplaceInitialState = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const getQuerySearch_1 = require("../../actions/marketplace/getQuerySearch");
const getQueryAutocomplete_1 = require("../../actions/marketplace/getQueryAutocomplete");
const getCategories_1 = require("../../actions/marketplace/getCategories");
const getRecentItems_1 = require("../../actions/marketplace/getRecentItems");
const getAllItemsAvailabilities_1 = require("../../actions/marketplace/getAllItemsAvailabilities");
const getQueryItems_1 = require("../../actions/marketplace/getQueryItems");
exports.marketplaceInitialState = {
    autocomplete: {
        data: [],
        loading: false,
        error: false,
        value: '',
    },
    categories: {
        data: [],
        mainCategories: [],
        loading: false,
        error: false,
        value: '',
    },
    recentItems: {
        data: [],
        loading: false,
        error: false,
        value: '',
    },
    owner: {
        error: false,
        loading: false,
        data: {},
    },
    slices: {
        availability: {
            error: false,
            loading: false,
            data: [],
        },
        items: {
            data: [],
            loading: false,
            searchLoading: false,
            error: false,
            meta: {},
        },
        inquiry: {
            error: false,
            loading: false,
        },
    },
};
const combineExtraReducers = (builder) => {
    (0, getQuerySearch_1.getQuerySearchExtraReducers)(builder);
    (0, getQueryAutocomplete_1.getQueryAutocompleteExtraReducers)(builder);
    (0, getCategories_1.getCategoriesExtraReducers)(builder);
    (0, getRecentItems_1.getRecentItemsExtraReducers)(builder);
    (0, getAllItemsAvailabilities_1.getAllItemsAvailabilitiesExtraReducers)(builder);
    (0, getQueryItems_1.getMarketQueryItemsExtraReducers)(builder);
};
exports.marketplaceSlice = toolkitRaw.createSlice({
    name: 'market',
    initialState: exports.marketplaceInitialState,
    reducers: {
        updateOwner: (state, action) => {
            state.owner.data = action.payload;
        },
        resetAvailabilities: (state) => {
            state.slices.availability.data = [];
        },
    },
    extraReducers: (builder) => {
        return combineExtraReducers(builder);
    },
});
_a = exports.marketplaceSlice.actions, exports.updateOwner = _a.updateOwner, exports.resetAvailabilities = _a.resetAvailabilities;
exports.default = exports.marketplaceSlice.reducer;
//# sourceMappingURL=index.js.map